<template>
  <div
    :class="$route.path.includes('/product-in-stock') ? 'inside-product__wrapper2' : 'inside-product__wrapper' "
    style="
      flex-grow: 0.8;
      display: flex;
      flex-direction: column;
      align-items: flex;
    "
    :style="$route.path.includes('/product-in-stock') ? 'margin-top: 56px' : getStyle()"
  >
    <!-- <div
      class="table__header"
      style="margin-bottom: 13px !important;margin-top: -12px;"
    >
      <button
        v-if="$route.path.includes('create-order') && getDressColors.length == 0"
        v-b-modal.add-custom
        class="button"
        style="border-radius:6px"
        @click="getMaterialVByMandP"
      >
        <b-icon-plus />
        Add Custom Dress
      </button>
    </div> -->
    <div class="insideProductTable">
      <table
        class="team_table"
        :class="{'button--disabled': getMaterialsByArticleNum.length == 0 }"
      >
        <thead>
        <tr>
          <th>
            {{ $t('MaterialVariantName') }}
          </th>
          <th>
            {{ $t('Quantity') }}
          </th>
          <th>
            {{ $t('Length') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in getMaterialsByArticleNum.productSingleMaterialVariantDtos"
          :key="item.materialVariantId"
          style="cursor: pointer"
        >
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.quantity === 1 ? item.quantity+` ${$t('Part')}` : item.quantity > 0 ? item.quantity+` ${$t('Parts')}` : "" }}
          </td>
          <td>
            {{ item.length === 1 ? item.length+` ${$t('Meter')}` : item.length > 0 ? item.length+` ${$t('Meters')}` : "" }}
          </td>
        </tr>
        <tr v-if="getMaterialsByArticleNum.totalCost > 0">
          <td
            colspan="10"
            style="padding: 10px; background-color: #f4f5f6;"
          >
            {{ $t("TotalPriceForVariants") }}: {{ getMaterialsByArticleNum.totalCost }} €
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- <CreateCustomOrderModal
      @createCustomOrder="createCustomOrder"
    /> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import CreateCustomOrderModal from '@/modals/CreateCustomOrderModal.vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    // CreateCustomOrderModal,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    productMatObj: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    addedArticle: {
      type: Array,
    },
    createOrder: {
      type: Boolean,
    },
  },
  data() {
    return {
      dummy: '',
      searchTerm: '',
      rows: [],
    };
  },
  computed: {
    ...mapGetters(['getMaterialsByArticleNum', 'getDressColors']),
  },
  watch: {
    productMatObj() {
      this.addRows();
    },
  },
  methods: {
    ...mapActions(['addOrderInStore', 'getMaterialVariantsToMDCPagination']),
    async createCustomOrder(obj) {
      await this.addOrderInStore(obj);
    },
    numbersWithcomma(value) {
      const options = {
        style: 'decimal', // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      return value.toLocaleString('en-US', options);
    },
    getStyle() {
      if (this.getDressColors.length != 0) {
        return 'margin-top: 112px'
        // eslint-disable-next-line no-else-return
      } else {
        return 'margin-top: 112px'
      }
    },
    addRows() {
      const x = this.productMatObj.productMaterialVariantDtos;
      const y = this.productMatObj.productMaterialQuantityDtos;

      this.rows = [...x, ...y];
    },

    // tdClass(row) {
    //   return row.vgtSelected ? 'row-clicked' : '';
    // },

    // onRowClick(p) {
    //   return p.selected ? 'selected' : '';
    // },
    async getMaterialVByMandP() {
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Meter',
      });
      await this.getMaterialVariantsToMDCPagination({
        pageNumber: 1,
        pageSize: 15,
        measurement: 'Part',
      });
    },
  },
};
</script>

<style scoped lang="scss">

.team_table td {
  padding: 16px 9px !important;
}
.orange-color {
  color: orange;
}
.red-color {
  color: red;
}
.green-color {
  color: green;
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}

tr:last-child {
  border-bottom: none !important;
}

.insideProductTable {
  width: 100%;
  padding-top: 16px
}

@media screen and (max-width: 1823px) {
  .insideProductTable {
    //border: 1px solid blue !important;
    //width: 100%;
    //margin-left: 30px;
  }

  .inside-product__wrapper{
    margin-left: 20px;
    border: 1px solid blue !important;
  }
}
@media screen and (max-width: 1400px) {
  .inside-product__wrapper{
    width: 100% !important;
    margin-left: 0px !important;
    // button{
    //   font-size: 11px;
    //   width: 100% !important;
    //   height: 36px;
    // }
  }
}

@media screen and (max-width: 1340px) {
  .inside-product__wrapper{
    width: 100% !important;
    margin-left: 0px !important;
    // button{
    //   font-size: 11px;
    //   width: 100% !important;
    //   height: 36px;
    // }
  }
  .inside-product__wrapper2 {
    //border: 1px solid blue !important;
    //width: 35% !important;
  }
}

@media screen and (max-width: 1200px) {
  .inside-product__wrapper2 {
    width: 100%;
    margin-top: 56px !important;
  }
}
@media screen and (max-width: 896px) {
  .inside-product__wrapper {
    width: auto !important;
    flex-basis: 50%;
  }
}
</style>
